import { useEffect } from 'react';
import { compose } from '@reduxjs/toolkit';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Error from 'core/errors/Error';
import Button from 'core/buttons/Button';
import withAppState from 'hoc/withAppState';
import PageContent from 'layouts/PageContent';
import FundingSources from 'components/funding-sources/FundingSources';
import FundingSourceFilterValues from 'components/funding-sources/FundingSourceFilterValues';
import { resetGetFundingSourcesFailure } from 'app/features/funding-sources/fundingSourceSlice';
import FundingSourceBriefDetailsModal from 'components/funding-sources/FundingSourceBriefDetailsModal';

import { permissions } from 'app/data/permissions';
import { HasPermission } from 'hoc/withRole';

import { buildRoute } from 'routes';

function ListFundingSource({ isNetworkError }) {
  const fundingSourceState = useSelector((state) => state.fundingSources.index);

  const { isError, errorCode } = fundingSourceState;

  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (isError) dispatch(resetGetFundingSourcesFailure());
  }, [isNetworkError]);

  if (isError)
    return (
      <Error
        status={errorCode}
        withInDashboard={true}
        onRetry={() => dispatch(resetGetFundingSourcesFailure())}
      />
    );

  return (
    <PageContent
      title="Funding Sources"
      rightTopEndContent={
        <HasPermission permission={permissions.CREATE_FUNDING_SOURCE}>
          <Button
            onClick={() => navigate(buildRoute('funding-sources.create'))}
            color="primary"
            startIcon={<AddIcon />}
          >
            Add Funding Source
          </Button>
        </HasPermission>
      }
    >
      <FundingSourceFilterValues />
      <FundingSources />
      <FundingSourceBriefDetailsModal />
    </PageContent>
  );
}

export default compose(withAppState)(ListFundingSource);
